import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import DisplayTemplateSection from "./DisplayTemplateSection";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";
import IconButton from "@material-ui/core/IconButton";
import CreateIcon from "@material-ui/icons/Create";
import PublishIcon from "@material-ui/icons/Publish";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Typography } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import PDFViewer from "../PDFViewer";
import { AutoSizer } from "react-virtualized";
import axios, { contentClient } from "../../AxiosClient";
import ActionButton from "../ActionButton";
import { withSnackbar } from "notistack";
import { Trans } from "react-i18next";
import Alert from "@material-ui/lab/Alert";
import TemplateInfo from "../template/TemplateInfo";
import { connect } from "react-redux";
import { canDisplay, isVideoJsMime, normaliseMime } from "./MimeTypeHelper";
import GetAppIcon from "@material-ui/icons/GetApp";
import VideoPlayer from "../VideoPlayer";
import {
  setCustomFields,
} from "../../redux/actions/customFieldsActions";
export class DisplayTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      left: [],
      middle: [],
      right: [],
      selected: 0,
      editIcon: false,
      settings: {},
      tabsSelected: 0,
      docContent: null,
      contentType: "",
      showAlert: true,
      saving: false,
      isFile: false,
      canView: true,
      fileName: "",
      isVideo: false,
      canDisplayHtml: false,
      canDisplayPdf: false,
      displayAs: "pdf",
      sectionsRendered: [],
      templateLoaded: false,
    };
  }
  setupTemplate = (template, contentSections) => {
    if (template.fileId) {
      axios
        .get(
          `/document/file/${template.fileId}?selectedFormat=${
            this.state.displayAs
          }`
        )
        .then((res) => {
          if (res.data.contentType === "application/pdf") {
            this.setState({
              docContent: this.base64ToArrayBuffer(res.data.byteString),
              contentType: res.data.contentType,
              canDisplayHtml: res.data.canDisplayHtml,
              canDisplayPdf: res.data.canDisplayPdf,
            },() => {this.props.onLoaded && this.props.onLoaded();});
          } else {
            let blob = new Blob();
            blob = new Blob([this.base64ToArrayBuffer(res.data.byteString)], {
              type: res.data.contentType,
            });
            const objectURL = URL.createObjectURL(blob);
            this.setState({
              docContent: objectURL,
              contentType: res.data.contentType,
              isFile: true,
            },() => {this.props.onLoaded && this.props.onLoaded();});
          }
        });
      return;
    }
    if (template.layoutData) {
      this.setState({ settings: JSON.parse(template.layoutData) });
    } else if (template.template) {
      this.setState({ settings: JSON.parse(template.template.layoutData) });
    }
    let left = [];
    let right = [];
    let middle = [];
    let sections;
    if (this.props.currentRevision) {
      if (this.props.currentRevision.sectionsDTOs) {
        sections = this.props.currentRevision.sectionsDTOs;
      } else {
        sections = this.props.currentRevision.sectionRVOs;
      }
    } else if (this.props.template && this.props.template.templateSections) {
      sections = this.props.template.templateSections;
    } else if (this.props.template && this.props.template.sectionsDTOs) {
      sections = this.props.template.sectionsDTOs;
    }
    for (var i = 0; i < sections.length; i++) {
      if (
        (this.props.templatePicker && !sections[i].deleted) ||
        (this.props.isNotTemplate && !this.props.isDiff)
      ) {
        if (sections[i].sectionColumn === "middle") {
          middle.push(sections[i]);
        } else if (sections[i].sectionColumn === "left") {
          left.push(sections[i]);
        } else if (sections[i].sectionColumn === "right") {
          right.push(sections[i]);
        }
      } else if (this.props.isDiff) {
        if (sections[i].sectionColumn === "middle") {
          middle.push(sections[i]);
        } else if (sections[i].sectionColumn === "left") {
          left.push(sections[i]);
        } else if (sections[i].sectionColumn === "right") {
          right.push(sections[i]);
        }
      } else if (
        this.props.currentRevision &&
        this.props.currentRevision.template.templateSections.filter((s) => {
          return s.id === sections[i].sectionID;
        }).length > 0
      ) {
        if (sections[i].sectionColumn === "middle") {
          middle.push(sections[i]);
        } else if (sections[i].sectionColumn === "left") {
          left.push(sections[i]);
        } else if (sections[i].sectionColumn === "right") {
          right.push(sections[i]);
        }
      }
    }
    this.setState({
      left: left.sort((a, b) => a.sortOrder - b.sortOrder),
      middle: middle.sort((a, b) => a.sortOrder - b.sortOrder),
      right: right.sort((a, b) => a.sortOrder - b.sortOrder),
    });
  };
  downloadOriginal = () => {
    var link = document.createElement("a");
    link.href = this.state.docContent;
    link.download = this.state.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  canDisplayHtml = () => {
    return (
      this.state.canDisplayHtml ||
      (this.props.currentRevision &&
        this.props.currentRevision.contentRVO &&
        this.props.currentRevision.contentRVO.file &&
        this.props.currentRevision.contentRVO.file.canDisplayHtml)
    );
  };
  canDisplayPdf = () => {
    return (
      this.state.canDisplayPdf ||
      (this.props.currentRevision &&
        this.props.currentRevision.contentRVO &&
        this.props.currentRevision.contentRVO.file &&
        this.props.currentRevision.contentRVO.file.canDisplayPdf)
    );
  };
  getFileContent = () => {
    if (
      this.props.currentRevision &&
      this.props.currentRevision.contentRVO &&
      this.props.currentRevision.contentRVO.file
    ) {
      if (
        this.props.currentRevision.contentRVO.file.contentType ===
        "application/pdf"
      ) {
        this.setState({
          docContent: this.base64ToArrayBuffer(
            this.props.currentRevision.contentRVO.file.byteString
          ),
          contentType: "application/pdf",
          isFile: true,
        });
      } else {
        let blob = new Blob();
        let contentType = this.props.currentRevision.contentRVO.file
          .contentType;
        contentType = normaliseMime(contentType);
        blob = new Blob(
          [
            this.base64ToArrayBuffer(
              this.props.currentRevision.contentRVO.file.byteString
            ),
          ],
          {
            type: contentType,
          }
        );
        const objectURL = URL.createObjectURL(blob);
        if (canDisplay(contentType)) {
          let isVideo = isVideoJsMime(contentType);
          this.setState({
            docContent: objectURL,
            contentType,
            isFile: true,
            canView: true,
            isVideo,
          },() => {this.props.onLoaded && this.props.onLoaded();});
        } else {
          this.setState({
            docContent: objectURL,
            canView: false,
            fileName: this.props.currentRevision.contentRVO.file.fileName,
          },() => {this.props.onLoaded && this.props.onLoaded();});
        }
        
      }
    } else {
      this.setState({ isFile: false });
      // this.props.onLoaded && this.props.onLoaded();
    }
  };
  componentDidMount() {
    // this.props.setCustomFields(this.props.template.customFields);
    this.getFileContent();
    if (this.props.template) {
      if (this.props.template.templateSections) {
        this.setupTemplate(this.props.template);
      } else if (this.props.template.sections) {
        this.setupTemplate(this.props.template);
      } else if (this.props.template.sectionsDTOs) {
        this.setupTemplate(this.props.template);
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    // if(this.props.template !== prevProps.template && this.props.templatePicker){
    //   this.props.setCustomFields(this.props.template.customFields);
    // }
    if (
      this.props.template &&
      !this.props.content &&
      (prevProps.template !== this.props.template ||
        prevProps.content !== this.props.content)
    ) {
      this.setupTemplate(this.props.template);
    } else if (
      this.props.template &&
      this.props.content &&
      (prevProps.template !== this.props.template ||
        prevProps.content !== this.props.content)
    ) {
      this.setupTemplate(this.props.template);
    }
    if (this.props.draft !== prevProps.draft) {
      this.setState({templateLoaded: false});
    }
    if (this.props.currentRevision !== prevProps.currentRevision) {
      this.getFileContent();
    }
    if (this.state.isVideo !== prevState.isVideo && !this.state.isVideo) {
    }

    if (
      this.state.sectionsRendered.length > 0 &&
      !this.state.templateLoaded
    ) {
      let mysections = this.state.left
        .map((s) => s.type)
        .concat(this.state.right.map((s) => s.type))
        .concat(this.state.middle.map((s) => s.type));
      let textsections = mysections.filter((t) => t === "tree" || t==="text");
      this.state.sectionsRendered.length >= textsections.length &&
        this.props.onLoaded &&
        this.setState({ templateLoaded: true }, () => this.props.onLoaded());
    }
  }
  onRenderComplete = (sectionId) => {
    let sectionsRendered = this.state.sectionsRendered;
    if (
      Array.isArray(sectionsRendered) &&
      sectionsRendered.indexOf(sectionId) < 0
    ) {
      sectionsRendered.push(sectionId);
      this.setState((prev) => ({ sectionsRendered: sectionsRendered }));
    }
  };

  getMainWidth = () => {
    let width = 100;

    if (this.state.left.length > 0) {
      width = width - 20;
    }

    if (this.state.right.length > 0) {
      width = width - 20;
    }

    return width + "%";
  };

  base64ToArrayBuffer = (base64) => {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  };
  render() {
    this.styleBorder = { margin: "8px", breakInside: "avoid" };
    this.state.settings.type === "borders"
      ? (this.styleBorder = {
          borderColor: this.state.settings.border.colour,
          borderStyle: this.state.settings.border.style,
          borderWidth: this.state.settings.border.width,
          margin: "8px",
          breakInside: "avoid",
        })
      : (this.styleBorder = { margin: "8px", breakInside: "avoid" });
    let { document, template } = this.state;
    let title = "";
    if (this.props.title) {
      title = this.props.title;
    } else if (this.props.document && this.props.document.userTitle) {
      title = this.props.document.userTitle;
    } else if (this.props.template) {
      title = this.props.template.name;
    }
    let id = "";
    if (this.props.currentRevision && this.props.currentRevision.contentRVO) {
      id = this.props.currentRevision.contentRVO.id;
    }
    return (
      <div
        style={{
          width: "100%",
          height: this.state.isFile ? "100%" : "",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!this.props.noHeader && (
          <CardHeader
            className="ki-header"
            // style={{ paddingTop: 0, paddingBottom: 0 }}
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
            }}
            title={title}
            subheader={this.getSubheader()}
            subheaderTypographyProps={{ className: "pdf-hide" }}
            titleTypographyProps={{ component: "h1", id: "document-title" }}
            avatar={
              this.props.close && (
                <IconButton onClick={this.props.onClose}>
                  {this.props.reverseClose ? (
                    <ArrowForwardIcon />
                  ) : (
                    <ArrowBackIcon />
                  )}
                </IconButton>
              )
            }
            action={
              <div style={{ display: "flex" }} className="pdf-hide">
                {this.props.isRevision &&
                  (this.state.canDisplayHtml || this.state.canDisplayPdf) && (
                    <div style={{ textAlign: "center" }}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">
                          {this.props.t("document_display_as")}
                        </FormLabel>
                        <Typography component="div">
                          <Grid
                            component="label"
                            container
                            alignItems="center"
                            spacing={1}
                          >
                            <Grid item>
                              <Trans i18nKey="global_html" />
                            </Grid>
                            <Grid item>
                              <Switch
                                color="default"
                                aria-label={
                                  this.state.displayAs === "pdf"
                                    ? "View in HTML format"
                                    : "View in PDF format"
                                }
                                checked={
                                  this.state.displayAs === "pdf" &&
                                  this.state.canDisplayPdf
                                }
                                disabled={
                                  !this.state.canDisplayHtml ||
                                  !this.state.canDisplayPdf
                                }
                                onChange={(e) => {
                                  this.setState(
                                    {
                                      displayAs: e.target.checked
                                        ? "pdf"
                                        : "html",
                                    },
                                    () =>
                                      this.setupTemplate(this.props.template)
                                  );
                                }}
                                name="displayas"
                              />
                            </Grid>
                            <Grid item>
                              <Trans i18nKey="global_pdf" />
                            </Grid>
                          </Grid>
                        </Typography>
                      </FormControl>
                    </div>
                  )}
                {this.props.hasDraft &&
                  this.props.hasLive &&
                  !this.props.isDiff && (
                    <>
                      {this.props.toggleDraft && (
                        <>
                          {this.props.draft ? (
                            <>
                              <Button
                                onClick={this.props.toggleDraft}
                                style={{ marginTop: 4, marginRight: 20 }}
                              >
                                {this.props.t("view_live_revision")}
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                onClick={this.props.toggleDraft}
                                style={{ marginTop: 4, marginRight: 20 }}
                              >
                                {this.props.t("view_draft_revision")}
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                {!this.props.noEdit &&
                  !this.props.diff && (
                    <div style={{ display: "flex" }}>
                      {this.props.template &&
                        this.props.template.isLive === false &&
                        this.props.template.isDraft === false && (
                          <div style={{ marginRight: 10 }}>
                            <ActionButton
                              id="make-draft-button"
                              loading={this.state.saving}
                              onClick={this.makeRevisionDraft}
                              style={{ marginTop: 4, marginRight: 20 }}
                            >
                              <Trans i18nKey="content_setup_make_draft" />
                            </ActionButton>
                          </div>
                        )}
                      {((this.props.isNotTemplate &&
                        (this.props.isRevision ||
                          this.props.currentRevision.userIsTopicExpert)) ||
                        (!this.props.isNotTemplate &&
                          this.props.user.userPermits.roles.contentAdmin)) && (
                        <IconButton
                          id="edit-content-template"
                          aria-label="Edit template"
                          onClick={this.props.editTemplate}
                          disabled={
                            this.props.template &&
                            this.props.template.isLive &&
                            this.props.revisionEdit
                          }
                        >
                          <CreateIcon />
                        </IconButton>
                      )}
                      {!this.props.isNotTemplate && (
                        <TemplateInfo template={this.props.template} />
                      )}
                    </div>
                  )}
              </div>
            }
          />
        )}
        {this.state.docContent ? (
          <>
            {this.state.contentType === "application/pdf" ? (
              <div style={{ flex: 1, overflow: "auto" }}>
                <PDFViewer
                  data={this.state.docContent}
                  onMount={this.props.onMount}
                  onSearchMatchesUpdate={this.props.onSearchMatchesUpdate}
                  onLoaded={this.props.onLoaded}
                  isSearch={this.props.isSearch}
                  searchString={this.props.searchString}
                  previousMatch={this.props.previousMatch}
                  nextMatch={this.props.nextMatch}
                />
              </div>
            ) : (
              <div id="overlay" style={{ flex: 1 }}>
                {this.state.canView ? (
                  <>
                    {this.state.isVideo ? (
                      <VideoPlayer
                        onPlaybackError={() =>
                          this.setState({ canView: false })
                        }
                        contentType={this.state.contentType}
                        sources={[
                          {
                            src: this.state.docContent,
                            type: this.state.contentType,
                          },
                        ]}
                        controls
                        fill
                        preload="auto"
                        responsive
                      />
                    ) : (
                      <iframe
                        onLoad={() => {
                          this.props.onLoaded && this.props.onLoaded()
                        }}
                        style={{ width: "100%", height: "99%" }}
                        id={"documentframe-" + this.props.documentId}
                        frameborder="0"
                        src={this.state.docContent}
                        sandbox="allow-forms allow-pointer-lock allow-popups allow-modals allow-same-origin allow-scripts"
                      />
                    )}
                  </>
                ) : (
                  <div style={{ textAlign: "center", marginTop: 100 }}>
                    {this.props.currentRevision.contentRVO.file
                      .failedToGetContent ? (
                      <Typography variant="body1">
                        {this.props.t("file_conversion_failed")}
                      </Typography>
                    ) : (
                      <Typography variant="body1">
                        {this.props.t("display_document_cannot_view")}
                      </Typography>
                    )}
                    <Typography variant="body1">
                      {this.props.t(
                        "display_document_cannot_view_download_original"
                      )}
                    </Typography>
                    <ActionButton
                      size="large"
                      onClick={this.downloadOriginal}
                      variant="outlined"
                      startIcon={<GetAppIcon />}
                      style={{ marginTop: 20 }}
                    >
                      {this.props.t(
                        "display_document_cannot_view_download_original_button"
                      )}
                    </ActionButton>
                  </div>
                )}
              </div>
            )}
          </>
        ) : (
          <>
            {this.state.showAlert &&
              this.props.template &&
              this.props.template.missingSection && (
                <div style={{ marginLeft: 30, marginRight: 30 }}>
                  <Alert
                    severity="warning"
                    onClose={() => {
                      this.setState({ showAlert: false });
                    }}
                  >
                    {this.props.t("display_template_section_missing")}
                  </Alert>
                </div>
              )}
            <CardContent
              className="mark-parent"
              id={"contentframe-" + id}
              style={{
                height: "100%",
                // flexDirection: "row",
                // display: "flex",
                // flex: 1,
                display: "table",
                width: "100%",
                boxSizing: "border-box",
                overflow: "auto",
                maxHeight: this.props.isSearch ? 600 : null,
              }}
            >
              {this.state.left.length > 0 && (
                <div
                  style={{
                    display: "table-cell",
                    // display: "flex",
                    // flex: 0.25,
                    // flexDirection: "column",
                    margin: "8px",
                    width: "20%",
                  }}
                >
                  {this.state.left.map((section, idx) => (
                    <div>
                      <Card
                        key={idx}
                        id="card"
                        style={{ margin: "8px" }}
                        className="template-card"
                      >
                        <DisplayTemplateSection
                          customFields={this.props.customFields}
                          isDiff={this.props.isDiff}
                          diffSection={
                            this.props.diffRevision &&
                            this.props.diffRevision.sectionRVOs
                              ? this.props.diffRevision.sectionRVOs.filter(
                                  (r) => r.sectionID === section.sectionID
                                )[0]
                              : null
                          }
                          editSection={this.editSection}
                          deleteSection={this.deleteSection}
                          idx={idx}
                          section={section}
                          onRenderComplete={this.onRenderComplete}
                        />
                      </Card>
                    </div>
                  ))}
                </div>
              )}
              <div
                style={{
                  display: "table-cell",
                  // display: "flex",
                  // flex: 1,
                  // flexDirection: "column",
                  margin: "8px",
                  width: this.getMainWidth(),
                }}
              >
                {this.state.settings.type === "cards" &&
                  this.state.middle.map((section, idx) => (
                    <div style={{ breakInside: "avoid" }}>
                      <Card
                        id="card"
                        style={{ margin: "8px" }}
                        className="template-card"
                      >
                        <DisplayTemplateSection
                          customFields={this.props.customFields}
                          isDiff={this.props.isDiff}
                          diffSection={
                            this.props.diffRevision &&
                            this.props.diffRevision.sectionRVOs
                              ? this.props.diffRevision.sectionRVOs.filter(
                                  (r) => r.sectionID === section.sectionID
                                )[0]
                              : null
                          }
                          editSection={this.editSection}
                          deleteSection={this.deleteSection}
                          idx={idx}
                          section={section}
                          onRenderComplete={this.onRenderComplete}
                        />
                      </Card>
                    </div>
                  ))}
                {/* )} */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                    margin: "8px",
                  }}
                  id="middle-section-container"
                >
                  {this.state.settings.type === "tabs" ? (
                    <div style={{ breakInside: "avoid" }}>
                      <Tabs
                        value={this.state.tabsSelected}
                        onChange={this.changeTabSelected}
                      >
                        {this.state.middle.map((section, idx) => (
                          <Tab key={idx} label={section.name} />
                        ))}
                      </Tabs>
                      <SwipeableViews
                        style={{ width: "50%" }}
                        index={this.state.tabsSelected}
                        id="templatePages"
                      >
                        {this.state.middle.map((section, idx) => (
                          <div>
                            <DisplayTemplateSection
                              customFields={this.props.customFields}
                              isDiff={this.props.isDiff}
                              diffSection={
                                this.props.diffRevision &&
                                this.props.diffRevision.sectionRVOs
                                  ? this.props.diffRevision.sectionRVOs.filter(
                                      (r) => r.sectionID === section.sectionID
                                    )[0]
                                  : null
                              }
                              editSection={this.editSection}
                              deleteSection={this.deleteSection}
                              section={section}
                              onRenderComplete={this.onRenderComplete}
                            />
                          </div>
                        ))}
                      </SwipeableViews>
                    </div>
                  ) : null}
                  {this.state.settings.type === "borders"
                    ? this.state.middle.map((section, idx) => (
                        <div style={this.styleBorder}>
                          <DisplayTemplateSection
                            customFields={this.props.customFields}
                            isDiff={this.props.isDiff}
                            diffSection={
                              this.props.diffRevision &&
                              this.props.diffRevision.sectionRVOs
                                ? this.props.diffRevision.sectionRVOs.filter(
                                    (r) => r.sectionID === section.sectionID
                                  )[0]
                                : null
                            }
                            editSection={this.editSection}
                            deleteSection={this.deleteSection}
                            section={section}
                            onRenderComplete={this.onRenderComplete}
                          />
                        </div>
                      ))
                    : null}
                </div>
              </div>
              {this.state.right.length > 0 && (
                <div
                  style={{
                    display: "table-cell",
                    // display: "flex",
                    // flex: 0.25,
                    // flexDirection: "column",
                    margin: "8px",
                    width: "20%",
                  }}
                >
                  {this.state.right.map((section, idx) => (
                    <div style={{ breakInside: "avoid" }}>
                      <Card
                        id="card"
                        style={{ margin: "8px" }}
                        className="template-card"
                      >
                        <DisplayTemplateSection
                          customFields={this.props.customFields}
                          isDiff={this.props.isDiff}
                          diffSection={
                            this.props.diffRevision &&
                            this.props.diffRevision.sectionRVOs
                              ? this.props.diffRevision.sectionRVOs.filter(
                                  (r) => r.sectionID === section.sectionID
                                )[0]
                              : null
                          }
                          editSection={this.editSection}
                          deleteSection={this.deleteSection}
                          section={section}
                          onRenderComplete={this.onRenderComplete}
                        />
                      </Card>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </>
        )}
      </div>
      // </>
    );
  }

  makeRevisionDraft = () => {
    contentClient({
      method: "patch",
      url: `/knowledgeitem/${this.props.template.knowledgeItemId}/revision/${
        this.props.template.revisionId
      }`,
      data: { ...this.props.template, makeDraft: true },
    })
      .then((res) => {
        this.setState({ saving: false });
        this.props.enqueueSnackbar(
          <Trans i18nKey="revision_made_draft_successfully">
            revision_made_draft_successfully
          </Trans>,
          { variant: "success" }
        );
      })
      .catch((err) => {
        this.setState({ saving: false });
        this.props.enqueueSnackbar(
          <Trans i18nKey="revision_made_draft_error">
            revision_made_draft_error
          </Trans>,
          { variant: "error" }
        );
      });
  };

  changeTabSelected = (event, value) => {
    this.setState({ tabsSelected: value });
  };

  getSubheader = () => {
    if (this.props.isDiff) {
      return null;
    }
    if (this.props.currentRevision) {
      if ((this.props.currentRevision.isDraft === true) || 
        (this.props.currentRevision.contentRVO && this.props.currentRevision.contentRVO.draft === true)) {
        return <>{this.props.t("ki_draft_revision")}</>;
      } else if ((this.props.currentRevision.isLive === true) ||
        (this.props.currentRevision.contentRVO && this.props.currentRevision.contentRVO.live === true)) {
        return <>{this.props.t("ki_live_revision")}</>;
      } else {
        return <>{this.props.t("global_revision") + " " + this.props.currentRevision.revisionNumber}</>;
      }
    }
  };

  clear() {
    this.setState(
      { template: {} },
      { left: [] },
      { middle: [] },
      { right: [] }
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
const mapDispatchToProps = {
  setCustomFields,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withSnackbar(DisplayTemplate)));
